import { observable, runInAction } from 'mobx';
import { MCCommandModel, IMCCommandServices, MCCommandDetailModel } from './../services/matchCardCommand_services';

export type MCCommandStore = {
  mCCommand: {
    data: Array<MCCommandModel>;
    message: string;
    isSuccess: boolean;
    paging: {
      totalCount: number;
      totalPage: number;
      pageSize: number;
    };
  };
  mCCommandDetailResponse: {
    data?: MCCommandDetailModel;
    message: string;
    isSuccess: boolean;
    recordsTotal: number;
    resultsCount: number;
    pagesCount: number;
  };
  updateMCWORoutingResponse: {
    message: string;
    isSuccess: boolean;
  };
};

export interface IMCCommandPresenter {
  createStore(): MCCommandStore;
  getListMCCommand(store: MCCommandStore, data: object): Promise<void>;
  getMCCommandDetail(store: MCCommandStore, id: string): Promise<void>;
  updateMCWORouting(store: MCCommandStore, data: any): Promise<void>;
}

export function createMCCommandPresenter({
  mCCommandServices,
}: {
  mCCommandServices: IMCCommandServices;
}): IMCCommandPresenter {
  return {
    createStore: (): MCCommandStore =>
      observable({
        mCCommand: {
          data: [],
          message: '',
          isSuccess: false,
          paging: {
            totalCount: 0,
            totalPage: 0,
            pageSize: 0,
          },
        },
        mCCommandDetailResponse: {
          data: undefined,
          message: '',
          isSuccess: false,
          resultsCount: 0,
          recordsTotal: 0,
          pagesCount: 0,
        },
        updateMCWORoutingResponse: {
          message: '',
          isSuccess: false,
        },
      }),
    getListMCCommand: async (store, data) => {
      try {
        const result = await mCCommandServices.getListMCCommand(data);

        runInAction(() => {
          store.mCCommand.data = result.data;
          store.mCCommand.isSuccess = result.isSuccess;
          store.mCCommand.message = result.message;
          store.mCCommand.paging = result.paging;
        });
      } catch (error) {
        console.log(error);
      }
    },
    getMCCommandDetail: async (store, id) => {
      try {
        const result = await mCCommandServices.getMCCommandDetail(id);

        runInAction(() => {
          store.mCCommandDetailResponse.data = result.data;
          store.mCCommandDetailResponse.isSuccess = result.isSuccess;
          store.mCCommandDetailResponse.message = result.message;
          store.mCCommandDetailResponse.pagesCount = result.pagesCount;
          store.mCCommandDetailResponse.recordsTotal = result.recordsTotal;
          store.mCCommandDetailResponse.resultsCount = result.resultsCount;
        });
      } catch (error) {
        console.log(error);
      }
    },
    updateMCWORouting: async (store, data) => {
      try {
        const result = await mCCommandServices.updateMCWORouting(data);

        runInAction(() => {
          store.updateMCWORoutingResponse.isSuccess = result.isSuccess;
          store.updateMCWORoutingResponse.message = result.message;
        });
      } catch (error) {
        console.log(error);
      }
    },
  };
}
